import { keepPreviousData, useQuery } from '@tanstack/vue-query'
import { computed, unref } from 'vue'
import { useCustomizationApi } from './use-customization'

const resolveQueryParam = (value, fallback) => {
  const resolved = unref(value)
  return resolved ?? fallback
}

export function useGetCustomPromptList({ page, limit, search }) {
  const { getCustomPromptList } = useCustomizationApi()

  const resolvedLimit = resolveQueryParam(limit, 7)
  const queryKey = ['custom-prompts-list', page, resolvedLimit, search]

  return useQuery({
    queryKey,
    queryFn: () =>
      getCustomPromptList({
        page: resolveQueryParam(page, 1),
        limit: resolvedLimit,
        search: resolveQueryParam(search, ''),
      }),
    placeholderData: keepPreviousData,
  })
}

export function useGetCustomPromptTable({ page, limit, search }) {
  const { getCustomPromptList } = useCustomizationApi()

  const resolvedLimit = resolveQueryParam(limit, 7)
  const queryKey = ['custom-prompts-table', page, resolvedLimit, search]

  return useQuery({
    queryKey,
    queryFn: () =>
      getCustomPromptList({
        page: resolveQueryParam(page, 1),
        limit: resolvedLimit,
        search: resolveQueryParam(search, ''),
      }),
    placeholderData: keepPreviousData,
  })
}

export function useGetSpecialtyMarkdown({ specialty }) {
  const { getSpecialtyMarkdown } = useCustomizationApi()

  return useQuery({
    queryKey: ['specialty-markdown', specialty],
    queryFn: () => getSpecialtyMarkdown({ specialty: specialty.value }),
    placeholderData: keepPreviousData,
    enabled: computed(() => !!specialty.value),
  })
}
